import React from "react";
import { Route } from "react-router-dom";
import LenderLandingPage from "../../screens/lender/LenderLandingPage";
import MyBorrowersList from "../../screens/lender/MyBorrowersList";
import LoansFPO from "../../screens/fpo/LoansFPO";
import ProspectBorrowers from "../../screens/lender/ProspectBorrowers";
import SendLoanProposalLender from "../../screens/lender/SendLoanProposalLender";
import FPOFarmerDetails from "../../screens/lender/FPOFarmerDetails";
import FPODocuments from "../../screens/lender/FPODocuments";
import ViewFPO from "../../screens/lender/ViewFPO";
import LoanRequests from "../../screens/lender/LoanRequests";
import LenderRequestDetail from "../../screens/lender/LenderRequestDetail";
import MyLoans from "../../screens/lender/MyLoan";
import ViewMyLoan from "../../screens/lender/ViewMyLoan";
import LenderProfile from "../../screens/lender/LenderProfile";

export const lenderRoutes = [
  <Route key="lender-home" path="/" element={<LenderLandingPage />} />,
  <Route
    key="lender-my-borrowers"
    path="/lender/my-borrowers"
    element={<MyBorrowersList />}
  />,
  <Route key="lender-fpo-loans" path="fpo/loans/" element={<LoansFPO />} />,
  <Route
    key="lender-prospect-borrowers"
    path="lender/prospect-borrowers"
    element={<ProspectBorrowers />}
  />,
  <Route
    key="lender-send-loan-proposal"
    path="lender/send-loan-proposal/:fpoId"
    element={<SendLoanProposalLender />}
  />,
  <Route
    key="lender-fpo-farmer-details"
    path="lender/fpo-farmer-details/:fpoId"
    element={<FPOFarmerDetails />}
  />,
  <Route
    key="lender-fpo-documents-details"
    path="lender/fpo-documents-details/:fpoId"
    element={<FPODocuments />}
  />,
  <Route
    key="lender-view-fpo"
    path="lender/view-fpo/:fpoId"
    element={<ViewFPO />}
  />,
  <Route
    key="lender-requests"
    path="lender/requests"
    element={<LoanRequests />}
  />,
  <Route
    key="lender-request-detail"
    path="lender/requests/:fpoId"
    element={<LenderRequestDetail />}
  />,
  <Route key="lender-my-loans" path="lender/my-loans" element={<MyLoans />} />,
  <Route
    key="lender-view-loan"
    path="lender/my-loans/:fpoId"
    element={<ViewMyLoan />}
  />,
  <Route
    key="lender-profile"
    path="lender/profile"
    element={<LenderProfile />}
  />,
];
